import { useCallback } from 'react';

import { AppModel, AppStatus, useUpdateApp } from '../../../../modules/Apps';
import { ConfirmationDialog } from '../../../common/ConfirmationDialog';
import { useToastNotification } from '../../../common/Toaster';

interface ActivateAppDialogProps {
  isOpen: boolean;
  handleClose: VoidFunction;
  app: AppModel;
}
export function ActivateAppDialog({ isOpen, handleClose, app: { appId } }: ActivateAppDialogProps) {
  const { mutateAsync, isPending } = useUpdateApp();
  const toaster = useToastNotification();

  const activateApp = useCallback(async () => {
    try {
      await mutateAsync({ appId, status: AppStatus.Enabled });
      toaster.showSuccess('Application was successfully activated!');
      handleClose();
    } catch (error) {
      toaster.showError('There was an error activating the application. Please, try again later.');
    }
  }, [mutateAsync, appId, toaster, handleClose]);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmButtonLabel="Activate"
      heading="Activate Application"
      text="Are you sure you want to activate this Application?"
      handleConfirm={activateApp}
      handleDismiss={handleClose}
      isConfirmDisabled={isPending}
    ></ConfirmationDialog>
  );
}
